import React from 'react'
import styled from 'styled-components'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import SignalStream from '../../../utils/svg/signal-stream.svg'

type Props = {
    icon: string
    styledIcon: StyleSheet
    title: string
    styledTitle: StyleSheet
    live: boolean
}

const Title = ({ icon, styledIcon, title, styledTitle, live }: Props): JSX.Element => {
    return (
        <Header>
            <IconHeader style={styledIcon}>
                <i className={icon}></i>
            </IconHeader>
            <div>
                <Name style={styledTitle}>{title}</Name>
                {live && (
                    <Live>
                        <Icon>
                            {/* <i className="fas fa-signal-alt" style={{ fontSize: 16 }}></i> */}
                            <SignalStream style={{ fontSize: '18px' }} />
                            Live
                        </Icon>
                    </Live>
                )}
            </div>
        </Header>
    )
}

export default Title

const Name = styled.div`
    color: var(--gray-800);
    font-size: 20px;
    font-weight: 600;
    line-height: 16px;
    text-transform: none;
    display: block;
`

const Live = styled.div`
    color: var(--gray-800);
    display: flex;
    font-size: 14px;
    font-weight: 300;
    line-height: 8px;
`

const Header = styled.div`
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    text-transform: none;
    font-family: 'SourceSansPro-SemiBold', sans-serif;
`

const IconHeader = styled.div`
    background-color: ${({ theme }) => theme['gray-200']};
    width: 34px;
    height: 34px;
    padding: 2px;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    font-size: 22px;
    color: ${({ theme }) => theme['gray-700']};
`

const Icon = styled.div`
    padding: 2px;
    height: 24px;
    width: fit-content;
    color: #017f60;
    background: #f0fffa;
    border-radius: 3px;

    margin-right: 8px;
    display: flex;
    gap: 4px;
    align-items: center !important;
    justify-content: center;
`
